import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const lookupService = {
    getLookupRoles, 
    getAllPermissions, 
    getLookupUsers,
    getLookupCompanies,
    getLookupJobs,
    getLookupDepartments,
    getLookupForms, 
    getLookupClasses, 
    getLookupMoas,
    getLookupTypes, 
    getLookupPurposes, 
    getLookupBrands,
    getLookupStatus,
    getLookupProducts,
    getLookupAIs,
    getAllModulePermissions,
    getLookupProductCreateUpdates,

    getLookupGroup,
    getLookupLocation,
    getLookupPropertyType,
    getLookupPropertyTenure,
    getLookupPropertyCategory,
    getLookupPropertyStatus,
    getLookupPropertyAction,
    getLookupAmenity,
    getMeetingRoom,
    getLookupSource,
};

const MODULE = {
    LOOKUP: 'lookup',
    ROLES: 'roles', 
    PERMISSIONS: 'permissions', 
    USERS: 'users', 
    COMPANIES: 'group-companies', 
    JOB: 'company-jobs',
    DEPARTMENTS: 'company-departments', 
    FORMS: 'rnd-forms', 
    CLASSES: 'rnd-classes', 
    MOAS: 'rnd-moas', 
    TYPES: 'rnd-types', 
    PURPOSES: 'rnd-purposes', 
    BRANDS: 'rnd-brands', 
    STATUS: 'rnd-status', 
    PRODUCTS: 'rnd-products', 
    AIS: 'rnd-ais',  
    PRODUCTCREATEUPDATES: 'rnd-product-create-updates', 

    GROUP: 'groups',
    LOCATION: 'company-locations',
    PROPERTYTYPE: 'property-types',
    PROPERTYTENURE: 'property-tenures',
    PROPERTYCATEGORY: 'property-categories',
    PROPERTYSTATUS: 'property-status',
    PROPERTYACTION: 'property-actions',
    AMENITY: 'amenities',
    MEETINGROOM: 'location-meeting-rooms',
    SOURCE: 'sources',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'

export function getLookupRoles() {
    const requestOptions = {
      params: {
        is_active: 1
      }
    }
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.ROLES}`, requestOptions)
}

export function getAllPermissions() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PERMISSIONS}`)
}

export function getLookupUsers() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.USERS}`)
}

export function getAllModulePermissions() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/module-permissions`)
}

export function getLookupCompanies() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.COMPANIES}`)
}

export function getLookupJobs() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.JOB}`)
}

export function getLookupDepartments(companyID) {
  let requestOptions = {};
  if (companyID) {
    requestOptions.params = {
      company: companyID,
    }
  }
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.DEPARTMENTS}`, requestOptions)
}

export function getLookupForms() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.FORMS}`)
}

export function getLookupClasses() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.CLASSES}`)
}

export function getLookupMoas() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.MOAS}`)
}

export function getLookupTypes() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.TYPES}`)
}

export function getLookupPurposes() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PURPOSES}`)
}

export function getLookupBrands() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.BRANDS}`)
}

export function getLookupStatus() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.STATUS}`)
}

export async function getLookupProducts() {
  return await apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PRODUCTS}`)
}

export function getLookupAIs() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.AIS}`)
}

export function getLookupProductCreateUpdates() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PRODUCTCREATEUPDATES}`)
}

export function getLookupGroup() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.GROUP}`)
}

export function getLookupPropertyType() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PROPERTYTYPE}`)
}

export function getLookupPropertyTenure() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PROPERTYTENURE}`)
}

export function getLookupPropertyCategory() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PROPERTYCATEGORY}`)
}

export function getLookupPropertyStatus() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PROPERTYSTATUS}`)
}

export function getLookupPropertyAction() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PROPERTYACTION}`)
}

export function getLookupLocation() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.LOCATION}`)
}

export function getLookupAmenity() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.AMENITY}`)
}

export function getMeetingRoom() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.MEETINGROOM}`)
}

export function getLookupSource() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.SOURCE}`)
}